import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-check",
  "use": "various-check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"various-check\"><path class=\"st0\" d=\"M.287 16.7l3-5.1 6.6 3.9 8.5-15.1 5.2 3-11.3 20.3-12-7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol